import type { SVGProps } from 'react';
const SvgSortArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.444 12V3.333m0 8.667 4-4m-4 4-4-4"
    />
  </svg>
);
export default SvgSortArrow;
